import { render, staticRenderFns } from "./PortalRegisterListComponent.vue?vue&type=template&id=82995d74"
import script from "./PortalRegisterListComponent.vue?vue&type=script&lang=js"
export * from "./PortalRegisterListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports